import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class cTabSlider {
  constructor() {
    this.sliderInit();
  }

  sliderInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    this.Swipes = new Swiper('.c-tab-slider', {
      slidesPerView: 'auto',
      grabCursor: true,
      loop: false,
      speed: 500,
      allowTouchMove: true,
      // autoHeight: true,
      pagination: {
        el: '.c-tab-slider .slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.c-tab-slider .slider__button-next',
        prevEl: '.c-tab-slider .slider__button-prev',
      },
    });
  }
}

export default cTabSlider;
new cTabSlider();
